import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import UpdateRepository from '../Repositories/UpdateRepository'

class UpdateBloc {

    approveChannel = new Subject();
    detailChannel = new Subject();
    repository = new UpdateRepository()

    constructor() {
        this.approveChannel.next({status: apiResponse.INITIAL})
        this.detailChannel.next({status: apiResponse.INITIAL})
    }

    fetchApprove = async (query) => {
        this.approveChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.fetchApprove(query).then((result) => {
                this.approveChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.approveChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }


    fetchDetail = async (query) => {
        try {
            this.detailChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchDetail(query).then((result) => {
                this.detailChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.detailChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

}

export default UpdateBloc